'use client';

import React from 'react';
import {
  SuspenseLoader,
  // this is the one spot we actually should import it; everywhere else should import from this file
  // eslint-disable-next-line no-restricted-imports
  ErrorCatcher as TobyErrorCatcher,
  createToast,
} from '@knapsack/toby';
import { logError } from '@/services/datadog';

export * from 'react-error-boundary';

type Props = {
  children: React.ReactNode;
  /**
   * Show Banner or Toast
   */
  showToast?: boolean;
};

export const ErrorCatcher = ({ children, showToast }: Props) => {
  return (
    <TobyErrorCatcher
      onError={(error, errorInfo) => {
        logError(error, errorInfo);
        if (showToast) {
          createToast({
            title: 'Error',
            message: error.message,
            type: 'error',
          });
        }
      }}
    >
      {children}
    </TobyErrorCatcher>
  );
};

export const SuspenseAndErrorCatcher = ({
  children,
  fallback,
  delay,
  forceFallback,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  delay?: number;
  /**
   * Just show fallback - useful for designing
   */
  forceFallback?: boolean;
}) => {
  return (
    <SuspenseLoader
      delay={delay}
      fallback={fallback}
      forceFallback={forceFallback}
    >
      <ErrorCatcher>{children}</ErrorCatcher>
    </SuspenseLoader>
  );
};
